import React from 'react';
import PricingPlans from '../Global/PricingPlans';

const Pricing = () => <PricingPlans />;

export default Pricing;
